/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useSelector} from "react-redux";
import {useEffect} from "react";
import {BaseService} from "../Services/Core/BaseService";
import {DocumentUtils} from "../Utils/DocumentUtils";
import {useChangePage} from "./NavigationHooks";
import {useLoginEffect} from "../../../monitoring/src/Hooks/useLoginEffect";
export {useLoginEffect} from "../../../monitoring/src/Hooks/useLoginEffect";

export const useLoginRedirect = (targetUrl) => {
    const changePage = useChangePage();
    useLoginEffect(() => {
        if (window.location.pathname.toUpperCase() !== targetUrl.toUpperCase()) {
            changePage(targetUrl);
        }
    });
};

export const useLogoutEffect = (logic) => {
    const user = useSelector(state => state.userState.user);
    useEffect(() => {
        if (!BaseService.IS_AUTHENTICATED || user === null) {
            logic();
        }
    }, [user, BaseService.IS_AUTHENTICATED]);
}

export const useLogoutRedirect = (targetUrl) => {
    const changePage = useChangePage();
    useLogoutEffect(() => {
        if (window.location.pathname.toUpperCase() !== targetUrl.toUpperCase()) {
            changePage(targetUrl);
        }
    });
};
